import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import config from '@/config';
import useTranslations from '@/i18n/useTranslations';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Heading from '@/shared-components/text/components/Heading';
import Text from '@/shared-components/text/components/Text';

import './styles/AddException.css';

function AddExceptionContent({ setFormState, type, close }) {
  const t = useTranslations('common.forms.add_artwork');
  const [location, setLocation] = useState("");

  function addNewException() {
    const newException = {
      id: uuidv4(),
      element: `artwork_shipping_exception_${location.replace(/ /g,"_")}`,
      type,
      location,
      payer: "The collector",
      currency: "",
      price: ""
    };

    setFormState(prevValue => ({
      ...prevValue,
      artwork_shipping: {
        ...prevValue.artwork_shipping,
        artwork_shipping_exceptions: [...prevValue.artwork_shipping.artwork_shipping_exceptions, newException]
      }
    }));
  }

  return (
    <>
      <div className="add-artwork-shipping-form__add-exception-header">
        <Text className="add-artwork-shipping-form__add-exception-text" paragraph>
          {t('shipping.add_exception')}
        </Text>
        <XIcon className="add-artwork-shipping-form__add-exception-close" onClick={close}/>
      </div>

      <PublicFormInput 
        selectOptions={type === "COUNTRY_EXCEPTION" ? { options: config.forms.prefix_options, type: "country" } : { options: config.forms.continent_options }} 
        placeholder={type === "COUNTRY_EXCEPTION" ? t('shipping.country') : t('shipping.continent')}
        type="select" 
        element="artwork_add_new_exception" 
        value={location}
        onChange={(value) => setLocation(value)}
      />

      <ContinueButton className={`add-artwork-shipping-form__add-exception-add-button${!location ? " disabled-button" : ""}`} link onClick={()=>{addNewException(); close();}}>
        {t('shipping.add')}
      </ContinueButton>
    </>
  );
}

export default function AddException({ setFormState, type }) {
  const t = useTranslations('common.forms.add_artwork');
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="add-artwork-shipping-form__add-exception-button element-non-selectable" onClick={()=>setOpen(true)} role="button">
        <Heading className="add-artwork-shipping-form__add-exception-button-text">
          {type === "COUNTRY_EXCEPTION" ? t('shipping.add_country_exception') : t('shipping.add_continent_exception')}
        </Heading>
      </div>
      <GenericPopup 
        open={open}
        className="add-artwork-shipping-form__add-exception-popup"
        opacity
      >
        <AddExceptionContent 
          setFormState={setFormState} 
          type={type} 
          close={()=>setOpen(false)}
        />
      </GenericPopup>
    </>
  );
}
